module.exports = __webpack_public_path__ + "img/img14.d7a7cc64.png";